import { ITransportAccessibility } from '../../types/newbuilding/transportAccessibility';
import { IApplicationState } from '../../types/redux';

export const getTransportAccessibility = (state: IApplicationState): ITransportAccessibility | null => {
  const { transportAccessibilityRate } = state.newbuilding;

  return transportAccessibilityRate.transportAccessibility;
};
